import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b7fcfec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Performance")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Boosts")
const _hoisted_6 = { style: {"font-weight":"bold","word-break":"initial"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Attributes")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Parents ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_13 = { class: "hound-card__info" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h2 = _resolveComponent("n-h2")!
  const _component_scene_view = _resolveComponent("scene-view")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_career_icon = _resolveComponent("career-icon")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_custom_stat = _resolveComponent("custom-stat")!
  const _component_total_runs_icon = _resolveComponent("total-runs-icon")!
  const _component_win_rate_icon = _resolveComponent("win-rate-icon")!
  const _component_stamina_icon = _resolveComponent("stamina-icon")!
  const _component_plus_icon = _resolveComponent("plus-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_progress = _resolveComponent("n-progress")!
  const _component_n_statistic = _resolveComponent("n-statistic")!
  const _component_n_h4 = _resolveComponent("n-h4")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_stamina_refill_modal = _resolveComponent("stamina-refill-modal")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_ctx.hound)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_n_grid, {
          cols: "12",
          "x-gap": "24",
          "y-gap": "24",
          "item-responsive": "",
          responsive: "screen"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_gi, { span: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_h2, {
                  class: "thick-text",
                  style: {"text-align":"center","text-transform":"uppercase","font-family":"'syncopate'","margin-top":"1.5rem"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hound?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_scene_view, {
                  item: _ctx.renderArguments(),
                  ref: "arenaView"
                }, null, 8, ["item"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_gi, { span: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_h3, {
                  class: "thick-text",
                  style: {"padding-left":"1.5rem"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_card, {
                  class: "stats-card",
                  size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium',
                  "content-style": _ctx.breakpoints.sDown.matches ? 'display: contents;' : '',
                  bordered: _ctx.breakpoints.sDown.matches ? false : true,
                  style: _normalizeStyle([_ctx.breakpoints.sDown.matches ? 'background: none' : '', {"background":"rgba(0, 0, 0, .5)"}])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_grid, {
                      cols: "12",
                      "y-gap": "24",
                      "item-responsive": "",
                      responsive: "screen"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_gi, { span: "6 s:3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_custom_stat, { label: "Career" }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_career_icon)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_n_text, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.hound.firstPlace), 1)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_3,
                                _createVNode(_component_n_text, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.hound.secondPlace), 1)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_4,
                                _createVNode(_component_n_text, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.hound.thirdPlace), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_n_gi, { span: "6 s:3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_custom_stat, { label: "Total Runs" }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_total_runs_icon)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_n_text, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.hound.totalRuns), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_n_gi, { span: "6 s:3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_custom_stat, { label: "Win Rate" }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_win_rate_icon)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_n_text, {
                                  type: parseInt(_ctx.winRate) > 10 ? 'primary' : 'error'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.winRate) + "%", 1)
                                  ]),
                                  _: 1
                                }, 8, ["type"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_n_gi, { span: "6 s:3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_custom_stat, { label: "Stamina" }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_stamina_icon, { style: {"max-height":"100%"} })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_n_text, {
                                  type: _ctx.staminaPercentage <= 20 ? 'error' : 'primary'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.staminaPercentage) + "% ", 1),
                                    (_ctx.staminaPercentage < 100 && _ctx.ethReactive.userAddress === _ctx.hound.owner)
                                      ? (_openBlock(), _createBlock(_component_n_button, {
                                          key: 0,
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStaminaModal=true)),
                                          circle: "",
                                          ghost: "",
                                          size: "small",
                                          type: "primary"
                                        }, {
                                          icon: _withCtx(() => [
                                            _createVNode(_component_n_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_plus_icon)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["type"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["size", "content-style", "bordered", "style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.hound.boostAttributes().length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_n_h3, {
                class: "thick-text",
                style: {"padding-left":"1.5rem"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_n_card, {
                class: "stats-card",
                size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium',
                "content-style": _ctx.breakpoints.sDown.matches ? 'display: contents;' : '',
                bordered: _ctx.breakpoints.sDown.matches ? false : true,
                style: _normalizeStyle([_ctx.breakpoints.sDown.matches ? 'background: none' : '', {"background":"rgba(0, 0, 0, .5)"}])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_grid, {
                    cols: "4",
                    "y-gap": "24",
                    "item-responsive": "",
                    responsive: "screen"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hound.boostAttributes(), (trait, index) => {
                        return (_openBlock(), _createBlock(_component_n_gi, {
                          span: "2 m:1",
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_statistic, { class: "progress-statistic" }, {
                              label: _withCtx(() => [
                                _createVNode(_component_n_text, {
                                  type: trait.value > 50 ? 'success' : 'info'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trait.trait_type), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_n_progress, {
                                  type: "circle",
                                  status: trait.value > 50 ? 'success' : 'info',
                                  percentage: trait.value
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_6, [
                                      _createTextVNode("+" + _toDisplayString(trait.value), 1),
                                      (trait.display_type === 'boost_percentage')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "%"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["status", "percentage"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["size", "content-style", "bordered", "style"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_n_h3, {
          class: "thick-text",
          style: {"padding-left":"1.5rem"}
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_n_card, {
          class: "stats-card",
          size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium',
          "content-style": _ctx.breakpoints.sDown.matches ? 'display: contents;' : '',
          bordered: _ctx.breakpoints.sDown.matches ? false : true,
          style: _normalizeStyle([_ctx.breakpoints.sDown.matches ? 'background: none' : '', {"background":"rgba(0, 0, 0, .5)"}])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_grid, {
              cols: "10",
              "y-gap": "24",
              "item-responsive": "",
              responsive: "screen"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Generation"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.getGeneration()), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Sex"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.sex), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Color"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.mainColor().primaryName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Body Armor"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.armorMetadata().armor.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Head"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.armorMetadata().head.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Front Legs"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.armorMetadata().legsBack.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Back Legs"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.armorMetadata().legsBack.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Front Paws"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.armorMetadata().pawsFront.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Back Paws"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.armorMetadata().pawsBack.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_gi, { span: "5 m:2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_statistic, {
                      class: "custom-stat",
                      label: "Tail"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.hound.armorMetadata().tail.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["size", "content-style", "bordered", "style"]),
        (
      !['0', '1'].includes(_ctx.hound?.generation) &&
      !(_ctx.hound?.maleParent.token_id === _ctx.hound?.femaleParent.token_id && _ctx.hound?.maleParent.token_id === '1')
    )
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_n_h3, { style: {"padding-left":"1.5rem"} }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_n_grid, {
                cols: "12",
                "x-gap": "24",
                "y-gap": "24",
                "item-responsive": "",
                responsive: "screen"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parents, (parent) => {
                    return (_openBlock(), _createBlock(_component_n_gi, {
                      key: parent.id,
                      span: "12 m:6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_card, {
                          hoverable: "",
                          onClick: ($event: any) => (_ctx.openHound(parent.id.toString())),
                          style: {"background":"rgba(0, 0, 0, .5)"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["hound-card avatar", `
                avatar-component-${parent.extensionTraits ? parent.extensionTraits : parent.head[3]}-${parent.color[3]}
                avatar-neon-${parent.extensionTraits ? parent.extensionTraits : parent.head[3]}-${parent.color[2]}
              `])
                            }, [
                              _createElementVNode("div", null, [
                                _hoisted_10,
                                _hoisted_11,
                                _hoisted_12,
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_n_h4, { style: {"margin-bottom":"0"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_n_text, { type: "primary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(parent.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _hoisted_14,
                                  _createTextVNode(" " + _toDisplayString(parent.firstPlace) + " / " + _toDisplayString(parent.secondPlace) + " / " + _toDisplayString(parent.thirdPlace), 1)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_n_space, {
                                  vertical: "",
                                  justify: "center",
                                  style: {"height":"100%"},
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(parent.getGeneration()), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_n_divider),
        _createVNode(_component_n_modal, {
          show: _ctx.showStaminaModal,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showStaminaModal) = $event)),
          style: {"width":"max-content"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_stamina_refill_modal, {
              onRefillStamina: _ctx.resetHound,
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showStaminaModal=false)),
              hound: _ctx.hound
            }, null, 8, ["onRefillStamina", "hound"])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}